var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-tags-input',{class:_vm.className,attrs:{"only-existing-tags":true,"add-tags-on-comma":true,"add-tags-on-blur":true,"typeahead":true,"typeahead-style":"dropdown","typeahead-url":_vm.url}})}
var staticRenderFns = []

export { render, staticRenderFns }